import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import FirebaseIcon from 'mdi-react/FirebaseIcon';
import withAuthFirebase from '@/shared/components/auth/withAuthFirebase';
import LogInForm from '@/shared/components/loginForm/LogInForm';
import showResults from '@/utils/showResults';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import { useHistory } from 'react-router';
import GoogleAuthBtn from '../AuthBtn/googleAuthBtn';
import FacebookAuthBtn from '../AuthBtn/fbAuthBtn';
import MicrosoftAuthBtn from '../AuthBtn/microsoftAuthBtn';
import { login as loginAuth0 } from '../../../shared/components/auth/withAuth0';


const auth0Icon = `${process.env.PUBLIC_URL}/img/auth0.svg`;



const LogIn = ({ changeIsOpenModalFireBase }) => {
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [cookies, setCookie] = useCookies(['tranAuthToken']);
  const history = useHistory();

  const handleLogin = () => {
    console.log('login success', email, password);
    if (email && password) {
      axios.post('https://orca-app-5i5qx.ondigitalocean.app/api/admin/login', {
        email,
        password,
      }).then((res) => {
        console.log('res', res.data);
        if (res.status === 200) {
          setCookie('tranAuthToken', JSON.stringify(res.data.accessToken, {
            path: '/',
            maxAge: 3600, // Expires after 1hr
            sameSite: true,
          }));
          if (res.data.accessToken) {
            history.push('/booking_dashboard');
          }
        }
        // console.log(res);
      }).catch(err => console.log(err));
    }
  };
  return (
    <div className="account account--not-photo">
      <div className="account__wrapper">
        <div className="account__card">
          <div className="account__head">
            <h3 className="account__title">
              Welcome to
              <span className="account__logo">
                {' '}
                Tran
                <span className="account__logo-accent">Admin</span>
              </span>
            </h3>
            <h4 className="account__subhead subhead">
              Start your business easily
            </h4>
          </div>
          <LogInForm
            onSubmit={handleLogin}
            form="log_in_form"
            email={email}
            password={password}
            setEmail={setEmail}
            setPassword={setPassword}
          />
          {/* <div className="account__or">
          <p>Or Easily Using</p>
        </div> */}
          {/* <div className="account__social">
          <FacebookAuthBtn />
          <GoogleAuthBtn />
          <MicrosoftAuthBtn />
          <Button
            className="account__social-btn account__social-btn--firebase"
            onClick={changeIsOpenModalFireBase}
          >
            <FirebaseIcon />
          </Button>
          <Button
            className="account__social-btn account__social-btn--auth0"
            onClick={loginAuth0}
          >
            <img
              className="customizer__btn-icon"
              src={auth0Icon}
              alt="icon"
            />
          </Button>
        </div> */}
        </div>
      </div>
    </div>
  );
};

LogIn.propTypes = {
  changeIsOpenModalFireBase: PropTypes.func.isRequired,
};

export default withAuthFirebase(LogIn);
